/*
  Desktop-Pfeilnavigation für die Produktgalerie.
  Idee: Auf dem Desktop bleibt IMMER nur ein Bild im quadratischen Rahmen sichtbar
  (CSS blendet alle .product__media-item ohne .is-active aus). Diese Pfeile wechseln
  einfach, welches Bild aktiv ist – kein horizontales Scrollen, damit Neigung und
  Schatten des Rahmens (base.css, PDP-Quadrat) unangetastet bleiben.

  Bewusst NICHT an Dawns SliderComponent gekoppelt: die scrollt eine Bildliste und
  würde mit dem festen Quadrat-Rahmen kollidieren. Hier wird nur die Klasse .is-active
  umgehängt – dieselbe Klasse, die auch Dawns Thumbnail-Layout benutzt.

  Auf Mobil bleibt Dawns nativer Swipe-Slider aktiv; die Pfeile sind dort per CSS
  ausgeblendet (siehe base.css, @media max-width: 749px greift nicht auf .pdp-media-arrows).
*/
(function () {
  function initGallery(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const list = viewer.querySelector('.product__media-list');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('.product__media-item'));
    if (items.length < 2) return; // ein Bild: keine Pfeile nötig

    // Pfeil-Leiste erzeugen und über den Rahmen legen (viewer ist per CSS position: relative)
    const nav = document.createElement('div');
    nav.className = 'pdp-media-arrows';
    nav.innerHTML =
      '<button type="button" class="pdp-media-arrow pdp-media-arrow--prev" aria-label="Vorheriges Bild"></button>' +
      '<button type="button" class="pdp-media-arrow pdp-media-arrow--next" aria-label="Nächstes Bild"></button>';
    viewer.appendChild(nav);

    const prevBtn = nav.querySelector('.pdp-media-arrow--prev');
    const nextBtn = nav.querySelector('.pdp-media-arrow--next');

    // Wie weit die Pfeilmitte von der linken/rechten Bildkante nach INNEN rückt,
    // als Anteil der Bildbreite. 0 = genau auf der Kante, 0.5 = in der Mitte.
    // Größer = Pfeile näher zusammen. Hier zum Anpassen, falls gewünscht.
    const EDGE_RATIO = 0.08;

    function activeIndex() {
      const i = items.findIndex((el) => el.classList.contains('is-active'));
      return i < 0 ? 0 : i;
    }

    // Pfeile an die TATSÄCHLICH gemessene Lage des aktiven Bildes setzen.
    // Position relativ zum Viewer per getBoundingClientRect — unabhängig davon, welches
    // Element gerade Positionierungs-Bezug ist, und inklusive der margin-Verschiebung.
    function position() {
      const active = items[activeIndex()];
      if (!active || !active.offsetWidth) return; // unsichtbar (z. B. Mobil): nichts tun
      const vr = viewer.getBoundingClientRect();
      const ar = active.getBoundingClientRect();
      const left = ar.left - vr.left;
      const top = ar.top - vr.top;
      const cy = top + ar.height / 2;
      const inset = ar.width * EDGE_RATIO;
      prevBtn.style.left = left + inset + 'px';
      prevBtn.style.top = cy + 'px';
      nextBtn.style.left = left + ar.width - inset + 'px';
      nextBtn.style.top = cy + 'px';
    }

    function show(index) {
      const n = items.length;
      // vor/zurück, KEIN Kreislauf: an den Enden wird geklemmt statt umgebrochen.
      const target = Math.max(0, Math.min(n - 1, index));
      items.forEach((el, i) => el.classList.toggle('is-active', i === target));
      // Am ersten Bild kein Zurück, am letzten kein Vor.
      prevBtn.disabled = target === 0;
      nextBtn.disabled = target === n - 1;
      position();
    }

    prevBtn.addEventListener('click', () => show(activeIndex() - 1));
    nextBtn.addEventListener('click', () => show(activeIndex() + 1));

    // Startzustand + Neupositionierung, wenn sich die Bildgröße ändern kann:
    // beim Laden der Bilder (Größe steht erst dann fest) und bei Fenster-/Zoom-Änderung
    // (--cell wird dann neu berechnet, das Quadrat wächst/schrumpft mit).
    show(activeIndex());
    window.addEventListener('resize', position);
    window.addEventListener('load', position);
    items.forEach((item) => {
      const img = item.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', position);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
